module.exports = __webpack_public_path__ + "img/LT304940934.31ad44a7.png";